import { enforceSubscriptionAccess } from '~/middleware/guards/subscriptionGuard'
import { isOidcCallback } from '~/helpers/keycloakCallback'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $keycloak } = useNuxtApp()
  const config = useRuntimeConfig()
  const loginOptions = config.public.keycloakIdpHint
    ? { idpHint: config.public.keycloakIdpHint }
    : {}
  const triggerLogin = (reason) => {
    if (typeof $keycloak?.login === 'function') {
      $keycloak.login(loginOptions)
    } else {
      console.error(`[auth] keycloak login is unavailable: ${reason}`)
    }
    return abortNavigation()
  }

  if (!$keycloak) {
    console.error('[auth] keycloak is unavailable during route middleware')
    // Token exchange failed on a genuine Keycloak callback — strip the stale
    // params and reload to a clean URL so keycloak-js can start fresh.
    if (import.meta.client && isOidcCallback(config.public)) {
      window.location.replace(window.location.origin + window.location.pathname)
    }
    return abortNavigation()
  }

  if (!$keycloak.authenticated) {
    return triggerLogin('not authenticated')
  }

  try {
    if (typeof $keycloak.updateToken === 'function') {
      // Refresh if token expires within 30s.
      // Resolves: true (refreshed) / false (still valid). Rejects on refresh failure.
      await $keycloak.updateToken(30)
    }
  } catch (error) {
    console.error('[auth] session expired or refresh failed', error)
    return triggerLogin('refresh error')
  }

  if (!$keycloak.token) {
    return triggerLogin('missing token')
  }

  return enforceSubscriptionAccess(
    to,
    from,
    $keycloak.token,
    $keycloak.tokenParsed
  )
})
